module.exports = __webpack_public_path__ + "static/media/edit-primary.458e708e.svg";